import { Pipe, PipeTransform } from '@angular/core';

/**
 * Sanitize HTML
 */
@Pipe({
  name: 'place',
})
export class PlacePipe implements PipeTransform {
  /**
   * Transform
   *
   * @param value: string
   * @param type: string
   */
  transform(value: number): string {
    if (!value || isNaN(value)) {
      return '';
    }
    const number = value || 0;
    const suffixes: { [key: number]: string } = {
      1: 'st',
      2: 'nd',
      3: 'rd',
    };

    const lastTwoDigits = number % 100;
    const lastDigit = number % 10;

    // Special cases for 11, 12, and 13 as they don't follow the usual pattern
    if (lastTwoDigits === 11 || lastTwoDigits === 12 || lastTwoDigits === 13) {
      return number + 'th';
    }

    // Return the ordinal number with the appropriate suffix
    return number + (suffixes[lastDigit] || 'th');
  }
}
